import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NotificationComponent } from '@app/shared/notification/notification.component';

@Component({
  selector: 'app-auth-layout',
  imports: [RouterOutlet, NotificationComponent],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.css',
})
export class AuthLayoutComponent {}
